module.exports = __webpack_public_path__ + "static/media/prescriptions.5d8c81d6.svg";